export default "__VITE_ASSET__B5W__33w__"